// extracted by mini-css-extract-plugin
export default {"item":"UserProductVariationsColItem_item__eLFlS","item_connected":"UserProductVariationsColItem_item_connected__Ccnex"};